import Countdown from '../Countdown/Countdown'

import { useGetAvaxLastRewardUpdate } from '@/hooks/avaxRewards'

const AvaxReward = () => {
  const { data: lastRewardUpdate, refetch } = useGetAvaxLastRewardUpdate()

  if (!lastRewardUpdate) return null

  const rewardTimestamp = Number(lastRewardUpdate) + 30 * 60

  return <Countdown countdown={rewardTimestamp} onCountdownEnd={() => refetch()} />
}

export default AvaxReward
